import { type Weekday } from '../domain/Weekday'

export function formatWeekdayShort(weekday: Weekday) {
  switch (weekday) {
    case 'MON':
      return 'Mon'
    case 'TUE':
      return 'Tue'
    case 'WED':
      return 'Wed'
    case 'THU':
      return 'Thu'
    case 'FRI':
      return 'Fri'
    case 'SAT':
      return 'Sat'
    case 'SUN':
      return 'Sun'
  }
}
